import { AnalyticsQueryOrder } from '@hap/analytics'
import { Timespan } from '@hap/utils'

import { SavedQueryState } from './types'

export const LOAD_QUERY = 'LOAD_QUERY' as const
export const SET_TIMESPAN = 'SET_TIMESPAN' as const
export const SET_FILTERS = 'SET_FILTERS' as const
export const SET_ORDER = 'SET_ORDER' as const
export const SET_COLUMNS = 'SET_COLUMNS' as const
export const SET_ROWS = 'SET_ROWS' as const
export const SET_AGGREGATIONS = 'SET_AGGREGATIONS' as const
export const SET_TASK = 'SET_TASK' as const
export const SET_FIELDS = 'SET_FIELDS' as const

export const DEFAULT_INITIAL_VALUE: SavedQueryState['data']['params'] = {
  timespan: Timespan.toStaticTimespan(Timespan.DEFAULT_TIMESPAN_LAST_7_DAYS),
  relativeTimespan: Timespan.DEFAULT_TIMESPAN_LAST_7_DAYS,
  filters: [],
  orderBy: [] as AnalyticsQueryOrder[],
  columns: [],
  rows: [],
  aggregations: [],
  fields: [],
}
